import Joi from "joi";

const DepartmentSchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "string.empty": "Name is required.",
  }),
  departmentCode: Joi.string().trim().required().messages({
    "string.empty": "Department Code is required.",
  }),
}).unknown(true);

export default DepartmentSchema;
